import { parseTemplate } from 'url-template';
import { Query } from '~/Api/Analytics/VirtualBrand';
import { mapPagination, Pagination } from '~/Api/Pagination';
import ApiClient from '~/ApiClient';

import mapRecord from './mapRecord';
import Record from './Record';

export interface Result {
	items: Record[];
	pagination: Pagination;
}

export default async function findBrandsHistory(
	client: ApiClient,
	query: Query<string[] | string>,
	page: number,
	perPage: number
): Promise<Result> {
	const parameters = query.filterParameters.reduce(
		(parameters: { [key: string]: string | number | null | boolean }, parameter) => {
			parameters[`filter-${parameter.name}`] =
				typeof parameter.value === 'string' ? parameter.value : Array.from(parameter.value).join(',');
			return parameters;
		},
		{
			'include-context': false,
			currency: query.currency == 'source' ? null : query.currency,
			page,
			perPage,
		}
	);

	const therapeuticAreaFilter = query.filterParameters.find((parameter) => parameter.name === 'therapeutic-area');
	const therapeuticAreaFilterValue = therapeuticAreaFilter?.value ? therapeuticAreaFilter?.value : [];
	const normalizedTherapeuticAreaFilterValue = Array.isArray(therapeuticAreaFilterValue)
		? therapeuticAreaFilterValue
		: [therapeuticAreaFilterValue];

	const therapeuticAreaUrlPart = normalizedTherapeuticAreaFilterValue
		.map((value) => `&filter-therapeutic-area=${encodeURIComponent(value)}`)
		.join('');

	const url = parseTemplate(
		'analytics/virtual-brands/history{?filter-brand,filter-atc,include-context,currency,page,perPage}'
	);

	const request = await client.fetch(url.expand(parameters) + therapeuticAreaUrlPart);
	const response = await request.json();
	return {
		items: response.items.map(mapRecord),
		pagination: mapPagination(response.pagination),
	};
}
